/**
 * A strange class that tracks the start boosters on a level and before level
 */
export default class StartBoosterConfig {
  constructor() {
    this.data = [];
    this.preLevelAdBooster = [];
    this.requestHelpBoosters = [];
  }

  /**
   * Easily import data instead of accessing it and changing it
   * @param {Array<number>} data
   * @param {array<number>} preLevel
   * @param {Array<number>} requestHelp
   */
  importData(data, preLevel, requestHelp) {
    if (data) {
      this.data = data;
    }

    if (preLevel) {
      this.preLevelAdBooster = preLevel;
    }

    if (requestHelp) {
      this.requestHelpBoosters = requestHelp;
    }
  }

  destroy() {
    this.data = null;
    this.preLevelAdBooster = null;
    this.requestHelpBoosters = null;
  }

  /**
   * Sets that booster to selected
   * @param {number} lvlNr
   * @param {number} boosterNr
   */
  select(lvlNr, boosterNr) {
    if (!this.data[lvlNr]) {
      this.data[lvlNr] = [];
    }
    this.data[lvlNr][boosterNr] = true;
    G.sb('onStartBoosterConfigChange').dispatch();
  }

  /**
   * Sets that booster to deselected
   * @param {number} lvlNr
   * @param {number} boosterNr
   */
  deselect(lvlNr, boosterNr) {
    if (!this.data[lvlNr]) {
      this.data[lvlNr] = [];
    }
    this.data[lvlNr][boosterNr] = false;
    G.sb('onStartBoosterConfigChange').dispatch();
  }

  /**
   * Check if that booster is selected in that level
   * @param {number} lvlNr
   * @param {number} boosterNr
   * @return {boolean}
   */
  isSelected(lvlNr, boosterNr) {
    if (!this.data[lvlNr]) {
      return false;
    }
    return this.data[lvlNr][boosterNr];
  }

  /**
   * Get boosters that are selected for that level
   * @param {number} lvlNr
   * @returns {Array<number>}
   */
  getConfigForLevel(lvlNr) {
    return this.data[lvlNr] || [];
  }

  /**
   * Returns the number of the booster
   * @param {number} lvlNr
   * @returns {boolean}
   */
  getPreLevelAdBoosterNr(lvlNr) {
    if (!this.preLevelAdBooster[lvlNr]) {
      this.preLevelAdBooster[lvlNr] = game.rnd.pick([5, 7, 8]);
    }
    return this.preLevelAdBooster[lvlNr];
  }
}
